import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { IID_OL_ESPLETATO_OK } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDolEspletatoOkState extends EntityState<IID_OL_ESPLETATO_OK, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_ESPLETATO_OK })
@InterfaceDataStore(InterfaceName.ESPLETAMENTO_POSITIVO)
export class IIDolEspletatoOkStore extends EntityStore<IIDolEspletatoOkState> {
  constructor() {
    super([]);
  }
}